module.exports = __webpack_public_path__ + "img/bg-chat.7f57c9cb.png";